import type { ReactNode } from 'react';

/**
 * 実行状態の色はtokens.cssの--state-*が正本で、BPMN図・実行履歴・Task詳細で共通。
 * unknownはoutcome_unknown（成否不明）で、failed（失敗確定）とは別の色を割り当てる。
 */
export type BadgeTone =
  'neutral' | 'completed' | 'active' | 'failed' | 'cancelled' | 'awaiting' | 'unknown';

export interface BadgeProps {
  tone: BadgeTone;
  children: ReactNode;
}

/** 状態を表す小さなラベル。表示文言は呼び出し側が決める。 */
export function Badge({ tone, children }: BadgeProps) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}
